import { render, staticRenderFns } from "./CrearDerivacionImagen.vue?vue&type=template&id=30c4a385"
import script from "./CrearDerivacionImagen.vue?vue&type=script&lang=js"
export * from "./CrearDerivacionImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports